module.exports = __webpack_public_path__ + "static/media/foto-destaque-banco-de-pedidos.5a625053.jpg";